import { client } from "../../client";

/**
 * Handles a change in the health bars' states.
 * @param {Array} args packet arguments
 */
export const handleHP = (args: string[]) => {
  // A missing or non-numeric hp value would make this NaN, and `width: NaN%`
  // is dropped by the browser (with a parse error) rather than ignored.
  const hp = Number(args[2]);
  const percent_hp = (Number.isFinite(hp) ? hp : 0) * 10;
  let healthbox;
  if (args[1] === "1") {
    // Def hp
    client.hp[0] = Number(args[2]);
    healthbox = document.getElementById("client_defense_hp");
  } else {
    // Pro hp
    client.hp[1] = Number(args[2]);
    healthbox = document.getElementById("client_prosecutor_hp");
  }
  (<HTMLElement>healthbox.getElementsByClassName("health-bar")[0]).style.width =
    `${percent_hp}%`;
};
